import { TrainingFormWithTrainingDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'

import BlockSendSurveyModal from 'modules/trainings/pages/Trainings/Revamp/BlockedSendSurvey'
import SendSurveyModal from 'modules/trainings/pages/Trainings/Revamp/SendSurvey'

type Data = {
  trainingId: string
  formId: string
}

export const SendSurveyActivity: ActivityComponent<Data> = ({ trainingId, formId }) => {
  const { open, closeActivity } = useActivity()

  const { company } = useCurrentSession()
  const { data } = useQuery(TrainingFormWithTrainingDocument, {
    variables: { id: formId, trainingId: trainingId, companyId: company.id },
  })
  const trainingStatus = data?.trainings?.training?.status || 'draft'

  if (!open) return null

  if (trainingStatus !== 'active') {
    return <BlockSendSurveyModal trainingId={trainingId} formId={formId} onClose={closeActivity} />
  }

  return <SendSurveyModal trainingId={trainingId} formId={formId} onClose={closeActivity} />
}
